export const AUTOTEST_DOWNLOAD_INITIAL_GCP_REQUEST_CSV =
  "autotest-download-initial-gcp-request-csv";
export const AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV =
  "autotest-download-gcp-request-csv";
export const AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV_ALL =
  "autotest-download-gcp-request-csv-all";
export const AUTOTEST_DOWNLOAD_GCP_REQUEST_CSV_PROBLEM =
  "autotest-download-gcp-request-csv-problem";
export const AUTOTEST_DOWNLOAD_INITIAL_GCP_REQUEST_GPX =
  "autotest-download-initial-gcp-request-gpx";
export const AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX =
  "autotest-download-gcp-request-gpx";
export const AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX_ALL =
  "autotest-download-gcp-request-gpx-all";
export const AUTOTEST_DOWNLOAD_GCP_REQUEST_GPX_PROBLEM =
  "autotest-download-gcp-request-gpx-problem";
